{
  "nav": {
    "chat": "Session",
    "agents": "Agents",
    "history": "Historique",
    "files": "Fichiers",
    "changes": "Modifications",
    "mailbox": "Boîte aux lettres",
    "skills": "Compétences",
    "worktrees": "Worktrees",
    "design": "Design Studio",
    "officemap": "Plan du bureau",
    "settings": "Paramètres",
    "sddwizard": "Nouveau projet SDD",
    "specs": "Spécifications",
    "sddboard": "Tableau en direct",
    "autophase": "Phases",
    "fleet": "Flotte",
    "inspector": "Inspecteur",
    "prompts": "Prompts"
  },
  "brand": {
    "returnToChat": "{{name}} — retour au chat",
    "returnToChatDefault": "WrongStack — retour au chat"
  },
  "status": {
    "connected": "Connecté",
    "disconnected": "Déconnecté",
    "idle": "Inactif",
    "thinking": "Réflexion",
    "running": "En cours",
    "waiting": "En attente",
    "done": "Terminé",
    "stopped": "Arrêté"
  },
  "menu": {
    "moreWithHidden": "Plus, {{count}} éléments masqués",
    "moreOptions": "Plus d'options",
    "moreCompactHidden": "Plus — {{count}} panneaux/vues masqués, palette, thème, moniteurs",
    "moreCompact": "Plus — palette, thème, moniteurs",
    "moreFull": "Plus — palette, thème, raccourcis, moniteurs",
    "commandPalette": "Palette de commandes",
    "keyboardShortcuts": "Raccourcis clavier",
    "panels": "Panneaux",
    "views": "Vues",
    "theme": "Thème",
    "monitors": "Moniteurs",
    "fleetMonitor": "Moniteur de flotte",
    "agentsMonitor": "Moniteur d'agents"
  },
  "sidePanel": {
    "dragHint": "Glisser pour redimensionner · double-clic pour réinitialiser",
    "collapse": "Réduire le panneau (Ctrl+\\)"
  },
  "history": {
    "openDashboard": "Ouvrir le tableau de bord des sessions"
  },
  "agents": {
    "pending": "en attente…",
    "empty": "Aucun agent pour le moment",
    "emptyHint": "Les sous-agents apparaissent ici lorsque la flotte est active.",
    "runningCount": "{{count}} en cours",
    "totalCount": "{{count}} au total",
    "openFull": "Ouvrir la vue complète des agents",
    "agentsLive": "AGENTS · LIVE",
    "doneCount": "{{count}} terminés",
    "failedCount": "{{count}} échecs",
    "modelsLabel": "modèles",
    "shownLabel": "affichés",
    "totalLabel": "total",
    "leaderFleetTotals": "(leader {{leader}} · flotte {{fleet}})",
    "navHintJk": "j/k ou ↑↓ pour naviguer",
    "escCloseDetail": "· Échap pour fermer le détail",
    "noAgentsRunning": "Aucun agent en cours.",
    "contextUsage": "Utilisation du contexte",
    "lastToolLabel": "dernier :",
    "unknownSession": "Session inconnue",
    "sessionCopyTitle": "Session : {{sid}} — cliquer pour copier",
    "sessionWord": "session",
    "agentsCountSuffix_one": "{{count}} agent",
    "agentsCountSuffix_other": "{{count}} agents",
    "sessionTitle": "Session : {{sid}}",
    "projectSuffix": " · Projet : {{name}}",
    "statusIdle": "inactif"
  },
  "changes": {
    "fileCount_one": "{{count}} fichier",
    "fileCount_other": "{{count}} fichiers",
    "refreshTitle": "Actualiser les modifications",
    "loading": "Chargement des modifications…",
    "clean": "Aucune modification — l'arbre de travail est propre.",
    "selectPrompt": "Sélectionnez un fichier modifié pour voir son diff.",
    "unified": "Unifié",
    "unifiedTitle": "Diff unifié",
    "edit": "Modifier",
    "editTitle": "Diff côte à côte modifiable",
    "loadingDiff": "Chargement du diff…",
    "binary": "Fichier binaire — diff non affiché.",
    "tooLarge": "Fichier trop volumineux pour le diff."
  },
  "inspector": {
    "showPanel": "Afficher le panneau Inspecteur (Flotte / Agents / Audit)",
    "hidePanel": "Masquer le panneau Inspecteur",
    "label": "Inspecteur",
    "openAudit": "Ouvrir l'onglet Audit",
    "tabFleet": "Flotte",
    "tabAgents": "Agents",
    "tabAudit": "Audit",
    "collapseAria": "Réduire le panneau Inspecteur",
    "collapseTitle": "Réduire (Échap)",
    "noAgentsActive": "Aucun agent actif",
    "agentsAppearHint": "Les agents apparaissent ici lorsque la flotte est active.",
    "selected": "{{name}} (sélectionné)"
  },
  "nextSteps": {
    "header": "Prochaines étapes",
    "autoSubmitting": "envoi automatique dans",
    "clickToFill": "cliquer pour remplir",
    "clickToFillTitle": "Cliquez pour remplir : {{text}}",
    "auto": "auto",
    "willAutoSubmit": "Envoi automatique après le compte à rebours"
  },
  "mailbox": {
    "onlineCount": "{{count}} en ligne",
    "messages": "Messages",
    "deleteAllTitle": "Supprimer tous les messages",
    "deleteAll": "Tout supprimer",
    "deleting": "Suppression…",
    "purgeTitle": "Purger les messages obsolètes/orphelins",
    "purge": "Purger",
    "purging": "Purge…",
    "newLabel": "NOUVEAU",
    "empty": "Aucun message pour le moment.",
    "offlineCount": "+{{count}} hors ligne",
    "timeNow": "maintenant",
    "deleteAllConfirmTitle_one": "Supprimer {{count}} message ?",
    "deleteAllConfirmTitle_other": "Supprimer tous les {{count}} messages ?",
    "deleteAllConfirmBody": "Le fichier de boîte aux lettres est tronqué pour chaque agent. Action irréversible.",
    "purgeConfirmTitle": "Purger les messages obsolètes ?",
    "purgeConfirmBody": "Supprime les messages terminés de plus d'un jour et les messages incomplets de plus de 7 jours. Les messages actifs sont conservés.",
    "type": {
      "note": "Note",
      "ask": "Question",
      "assign": "Affectation",
      "steer": "Orienter",
      "btw": "Au passage",
      "broadcast": "Diffusion",
      "status": "Statut",
      "result": "Résultat"
    },
    "emptyDetail": "Aucun message sélectionné",
    "emptyDetailHint": "Cliquez sur un message dans le panneau Boîte aux lettres pour l'afficher ici.",
    "readBy": "Lu par",
    "backToChat": "Retour au chat",
    "completed": "Terminé",
    "everyone": "tout le monde",
    "closeTitle": "Fermer (Échap)",
    "replyTo": "En réponse à : {{id}}",
    "completedBy": "Terminé par {{name}}",
    "completedByAt": "Terminé par {{name}} le {{time}}",
    "outcome": "Résultat :",
    "task": "Tâche :",
    "messageNotFound": "Message introuvable",
    "messageNotFoundHint": "Ce message a peut-être été supprimé ou purgé."
  },
  "sessions": {
    "recentSessions": "Sessions récentes",
    "deleteEmptyTitle_one": "Supprimer {{count}} session vide ?",
    "deleteEmptyTitle_other": "Supprimer {{count}} sessions vides ?",
    "deleteEmptyConfirmBody": "Les sessions sans aucune utilisation de jetons sont supprimées du disque.",
    "filterPlaceholder": "Filtrer par titre, modèle, fournisseur…",
    "clearFilter": "Effacer le filtre",
    "noHistory": "Aucun historique",
    "noHistoryHint": "Vos conversations apparaîtront ici",
    "noMatches": "Aucun résultat",
    "noMatchesHint": "Essayez un autre filtre",
    "group": {
      "favorites": "Favoris",
      "today": "Aujourd'hui",
      "yesterday": "Hier",
      "thisWeek": "Cette semaine",
      "earlier": "Plus ancien"
    },
    "nicknamePlaceholder": "Surnom",
    "empty": "(vide)",
    "resuming": "reprise…",
    "active": "actif",
    "renameTitleNickname": "{{nickname}} — original : {{title}}",
    "renameTitle": "{{title}}\n\nDouble-cliquez pour renommer",
    "unfavorite": "Retirer des favoris",
    "markFavorite": "Marquer comme favori",
    "deleteSessionConfirmTitle": "Supprimer la session ?",
    "deleteSessionConfirmBody": "\"{{name}}\" sera supprimée du disque. Action irréversible.",
    "deleteSessionTitle": "Supprimer la session"
  },
  "sessionPanel": {
    "actions": {
      "abort": "Interrompre",
      "newSession": "Nouvelle session",
      "export": "Exporter",
      "compact": "Compresser",
      "newSessionTitle": "Démarrer une nouvelle session (Ctrl+N)",
      "exportTitle": "Exporter le chat en markdown (Ctrl+E)",
      "compactTitle": "Compresser la fenêtre de contexte",
      "clearTitle": "Effacer le contexte (Ctrl+L)"
    },
    "model": "Modèle",
    "modelTitle": "Changer de modèle (Ctrl+M)",
    "context": "Contexte",
    "contextTitle": "Cliquez pour un détail du contexte",
    "sessionLabel": "Session",
    "stats": {
      "messages": "Messages",
      "elapsed": "Écoulé",
      "tokens": "Jetons",
      "cost": "Coût",
      "iteration": "Itération",
      "agents": "Agents",
      "tokensSub": "{{in}} entrée / {{out}} sortie",
      "iterationOf": "sur {{max}}",
      "agentsRunning": "{{count}} en cours"
    },
    "plan": "Plan",
    "planComplete": "{{pct}}% terminé",
    "pinned": "Épinglés",
    "quickSettings": "Réglages rapides",
    "autonomy": "Autonomie",
    "autonomyOptions": {
      "off": "Désactivé",
      "suggest": "Suggérer",
      "auto": "Auto",
      "eternal": "Perpétuel",
      "eternal-parallel": "Perpétuel Parallèle"
    },
    "yolo": "Mode YOLO",
    "yoloTitle": "Ignorer les confirmations d'outils",
    "refine": "Affiner les prompts",
    "refineTitle": "Réécrire les prompts avant l'envoi",
    "sound": "Son à la fin",
    "soundTitle": "Jouer un doux carillon à la fin d'une exécution",
    "sessionId": "session {{id}}"
  },
  "fleet": {
    "status": {
      "running": "en cours",
      "done": "terminé",
      "failed": "échoué",
      "timeout": "expiré",
      "stopped": "arrêté"
    },
    "leader": "leader",
    "providerModel": "Fournisseur / Modèle",
    "elapsed": "Écoulé",
    "running": "en cours…",
    "iterations": "Itérations",
    "toolCalls": "Appels d'outils",
    "cost": "Coût",
    "budgetExtensions": "Extensions de budget",
    "activity": "Activité",
    "budgetWarning": "alerte budget",
    "contextWindow": "Fenêtre de contexte",
    "tokensUsed": "{{used}} / {{max}} jetons",
    "toolRunning": "en cours…",
    "lastTool": "dernier outil",
    "error": "Erreur",
    "finalOutput": "Sortie finale",
    "copyOutput": "Copier la sortie",
    "liveOutput": "Sortie en direct",
    "waitingOutput": "En attente de sortie…",
    "outputHint": "La sortie apparaît ici à mesure que l'agent diffuse du texte.",
    "toolLog": "Journal d'outils ({{count}} appels)",
    "fail": "échec",
    "moreTools": "+{{count}} outils de plus",
    "cardRunning": "en cours {{tool}}",
    "cardLastTool": "dernier : {{tool}}",
    "contextPercent": "Contexte {{pct}} %",
    "doneCount": "{{count}} terminé(s)",
    "errCount": "{{count}} err",
    "statusRunning": "en cours",
    "statusDone": "terminé",
    "statusFailed": "échec",
    "statusTimeout": "délai dépassé",
    "statusStopped": "arrêté",
    "sessionPrefix": "session :",
    "currentTask": "Tâche actuelle",
    "performance": "Performance",
    "uniqueTools": "Outils uniques",
    "avgPerTool": "moy. {{ms}}ms par outil",
    "context": "Contexte",
    "tokens": "Jetons",
    "ctxUsed": "{{pct}}% utilisé",
    "completed": "terminé",
    "budgetWarningTitle": "⚡ Alerte budget",
    "hittingLimit": "Atteint la limite {{kind}} ({{used}}/{{limit}})",
    "hittingLimitTitle": "⚡ atteint la limite {{kind}} ({{used}}/{{limit}})",
    "budgetExt_one": "{{count}} extension de budget",
    "budgetExt_other": "{{count}} extensions de budget",
    "extendedTimes_one": "L'agent a étendu son budget {{count}} fois pour des tâches longues",
    "extendedTimes_other": "L'agent a étendu son budget {{count}} fois pour des tâches longues",
    "errorLabel": "Erreur",
    "failureReason": "Raison de l'échec",
    "failed": "Échec",
    "fleetMonitor": "MONITEUR DE FLOTTE",
    "runningCount": "{{count}} en cours",
    "totalAgents_one": "{{count}} agent au total",
    "totalAgents_other": "{{count}} agents au total",
    "noLeader": "pas de leader",
    "closeFleet": "Fermer le moniteur de flotte",
    "colName": "Nom",
    "colStatus": "Statut",
    "colActivity": "Activité",
    "colIters": "Itér.",
    "colTools": "Outils",
    "colCost": "Coût",
    "colCtx": "CTX",
    "colExt": "Ext.",
    "colReason": "Raison",
    "noAgentsActive": "Aucun agent actif",
    "agentsAppear": "Les agents apparaissent ici quand la flotte est active.",
    "agentTimeline": "Chronologie des agents",
    "noAgentEvents": "Aucun événement de conversation d'agent encore.",
    "navHint": "↑↓ naviguer",
    "selectDetailHint": "↵ détail sélectionner",
    "escHint": "Esc désélectionner / fermer",
    "detailedView": "vue détaillée",
    "closeBtn": "✕ fermer",
    "selectAgentDetail": "Sélectionnez un agent pour des informations détaillées",
    "selectAgentBody": "Cliquez un agent de la liste pour métriques détaillées, journaux d'outils, sortie en flux et plus — similaire à la vue détaillée de l'historique.",
    "navigateWord": "naviguer",
    "selectWord": "sélectionner",
    "deselectWord": "désélectionner"
  },
  "context": {
    "wsNotConnected": "WebSocket non connecté",
    "noData": "Aucune donnée de débogage reçue. Le serveur ne prend peut-être pas en charge le débogage de contexte.",
    "title": "Décomposition du contexte",
    "windowUsage": "Utilisation de la fenêtre",
    "contextMode": "Mode de contexte",
    "fetching": "Récupération de la décomposition du contexte…",
    "systemPrompt": "Prompt système",
    "tools": "Outils",
    "messages": "Messages",
    "tokenAllocation": "Allocation des jetons",
    "systemTitle": "Système : {{tokens}}",
    "toolsTitle": "Outils : {{tokens}}",
    "messagesTitle": "Messages : {{tokens}}",
    "system": "Système",
    "toolBreakdown": "Décomposition des outils",
    "messagesSummary": "Messages ({{count}}) — {{total}} tok",
    "barWithTokens": "Fenêtre de contexte : {{tokens}} / {{max}} jetons ({{pct}})",
    "barPct": "Fenêtre de contexte : {{pct}}",
    "barClick": " — cliquez pour la répartition"
  },
  "refine": {
    "header": "✨ Affiner le prompt",
    "autoSend": "envoi auto dans {{count}} s",
    "cancelTitle": "Annuler (Échap)",
    "editLabel": "Modifier le prompt affiné :",
    "editPlaceholder": "Modifier le prompt affiné...",
    "useEdit": "Utiliser la modif.",
    "original": "Original",
    "refined": "Affiné",
    "yourLanguage": "(votre langue)",
    "refinedTitle": "Cliquez ou appuyez sur Entrée pour utiliser cette version",
    "english": "Anglais",
    "englishTitle": "Appuyez sur e pour la version anglaise",
    "hintRefined": "affiné",
    "hintEnglish": "Anglais",
    "hintOriginal": "original",
    "hintEdit": "modifier",
    "edit": "Modifier",
    "useRefined": "Utiliser l'affiné"
  },
  "specs": {
    "heading": "Spécifications",
    "subtitle": "Afficher et gérer le développement piloté par les spécifications",
    "empty": "Aucune spec trouvée. Utilisez {{command}} pour en créer une.",
    "tasks": "Tâches ({{count}})",
    "doneCount": "{{count}} terminée(s)",
    "runningCount": "{{count}} en cours",
    "pendingCount": "{{count}} en attente",
    "runTitle": "Exécuter cette spec comme un tableau AutoPhase en direct",
    "run": "Exécuter",
    "list": "Liste",
    "graph": "Graphe",
    "loadingTasks": "Chargement des tâches…"
  },
  "refresh": {
    "heading": "Vérificateur de résilience F5",
    "subtitle": "Confirme que la dernière session active, la transcription et l'état de l'UI survivent à un rafraîchissement de page. Ouvrez cette vue, puis appuyez sur F5 — chaque ligne verte doit rester verte.",
    "recordProbe": "Enregistrer une sonde",
    "latestSession": "Dernière session active",
    "restoredLocal": "Restauré depuis localStorage",
    "sessionIdExtra": "id de session : {{id}}",
    "noSessionYet": "aucune session n'a encore été démarrée",
    "activePointer": "Pointeur de session active",
    "lastVisited": "horodatage lastVisitedAt",
    "never": "jamais",
    "persistedEnv": "Environnement persisté",
    "transcriptRehydrate": "Réhydratation de la transcription",
    "localTranscript": "Transcription locale récupérée",
    "messagesExtra": "{{count}} messages, {{queued}} en file",
    "noMessages": "0 message",
    "noBleed": "Pas de fuite entre sessions",
    "bleedExtra": "lié={{bound}} vs actif={{active}}",
    "transcriptBinds": "la transcription se lie à la session active",
    "uiWorkspace": "Espace de travail UI",
    "noneValue": "(aucun)",
    "payloadSize": "Charge utile localStorage (4 clés) : {{count}} caractères",
    "probeLog": "Journal des sondes",
    "noProbes": "Aucune sonde pour le moment — appuyez sur le bouton « Enregistrer une sonde » en haut, ou sur F5 dans cette vue, pour enregistrer un contrôle de réhydratation.",
    "simulatedF5": "F5 simulé : relance de persist rehydrate"
  },
  "board": {
    "status": {
      "pending": "En attente",
      "in_progress": "En cours",
      "review": "Revue",
      "failed": "Échoué",
      "completed": "Terminé",
      "queued": "En file",
      "blocked": "Bloqué",
      "cancelled": "Annulé"
    },
    "newTaskTitle": "Nouvelle tâche",
    "newTaskPlaceholder": "Titre de la tâche…",
    "addTask": "Ajouter la tâche",
    "empty": "Aucune phase pour l'instant — lancez une exécution AutoPhase pour remplir le tableau.",
    "summary": "{{phases}} phases · {{tasks}} tâches",
    "phases": "Phases",
    "statusTab": "Statut",
    "dropHere": "Déposer les tâches ici",
    "emptySpec": "Aucune tâche dans cette spec pour le moment.",
    "depGraphHeading": "Graphe de dépendances",
    "worktreePrefix": "worktree : {{branch}}"
  },
  "debug": {
    "trendUp": "En hausse",
    "trendDown": "En baisse",
    "trendStable": "Stable",
    "heading": "Tableau de bord de débogage",
    "subtitle": "Surveillance en temps réel pour WrongStack WebUI",
    "refreshLabel": "Actualiser :",
    "lastUpdated": "Dernière mise à jour : {{time}}",
    "fetchFailed": "Échec de la récupération des métriques",
    "fileWatcher": "Observateur de fichiers",
    "watcherStatus": "Statut de l'observateur",
    "running": "En cours",
    "stopped": "Arrêté",
    "activeProjects": "Projets actifs",
    "projectsWatched": "Projets surveillés",
    "fileChanges": "Modifications de fichiers",
    "totalDetected": "Total détecté",
    "filesProcessed": "Fichiers traités",
    "afterHash": "Après filtre de hachage",
    "broadcastsSent": "Diffusions envoyées",
    "toClients": "Aux clients WebUI",
    "debounceResets": "Réinitialisations anti-rebond",
    "rapidWrites": "Écritures rapides successives",
    "avgDebounce": "Délai anti-rebond moyen",
    "actualDelay": "Délai réel appliqué",
    "totalDelay": "Délai total",
    "sumDelays": "Somme de tous les délais",
    "browserPerf": "Performances du navigateur",
    "heapUsed": "Tas utilisé",
    "jsHeap": "Tas JavaScript",
    "heapTotal": "Tas total",
    "totalHeap": "Taille totale du tas",
    "pageUptime": "Durée de la page",
    "sinceLoad": "Depuis le chargement",
    "rawData": "Données brutes"
  },
  "providerModels": {
    "using": "Utilisé",
    "noModelPicked": "(aucun modèle choisi)",
    "clearAllowlist": "Vider la liste autorisée",
    "clearAllowlistAria": "Vider la liste autorisée pour {{provider}}",
    "refresh": "Actualiser depuis le serveur",
    "refreshAria": "Actualiser la liste des modèles pour {{provider}}",
    "probing": "Vérification…",
    "use": "Utiliser",
    "useModelAria": "Utiliser le modèle {{model}} pour {{provider}}",
    "differsHint": "La liste vérifiée diffère de la liste enregistrée — relancez {{command}} pour persister."
  },
  "dock": {
    "expandChip": "Déplier {{label}}",
    "collapseChip": "Replier {{label}}",
    "ahead": "{{count}} en avance",
    "behind": "{{count}} en retard",
    "linesAdded": "{{count}} lignes ajoutées",
    "linesDeleted": "{{count}} lignes supprimées",
    "untrackedFiles": "{{count}} fichiers non suivis",
    "customizeTitle": "Personnaliser les puces du dock",
    "dockChips": "Puces du dock",
    "noActiveGoal": "Aucun objectif actif",
    "noActiveGoalDetail": "Lancez un objectif depuis le chat ou la commande goal."
  },
  "agentsMonitor": {
    "leaderBadge": "LEADER",
    "iters": "Itér.",
    "tools": "Outils",
    "activityBins": "Activité (12 bins)",
    "streamingOutput": "Sortie en flux",
    "recentTools": "Outils récents",
    "finalOutput": "Sortie finale",
    "heading": "Moniteur d'agents",
    "prevAgent": "Agent précédent",
    "nextAgent": "Agent suivant",
    "closeAria": "Fermer le moniteur d'agents",
    "hintPage": "←→ page",
    "hintNavigate": "↑↓ naviguer dans la liste",
    "hintEsc": "Esc fermer"
  },
  "terminal": {
    "resize": "Redimensionner les terminaux",
    "labelSingular": "Terminal",
    "labelPlural": "Terminaux",
    "projectShell": "Shell du projet",
    "maxTerminals": "Maximum {{count}} terminaux",
    "newTerminal": "Nouveau terminal",
    "restart": "Redémarrer le terminal actif",
    "closeAll": "Fermer tous les terminaux",
    "closeDock": "Fermer le dock de terminal (Ctrl+`)",
    "closeTab": "Fermer {{name}}",
    "processExited": "[processus terminé avec le code {{code}}]"
  },
  "sessionWatch": {
    "liveStream": "Flux en direct",
    "events_one": "{{count}} événement",
    "events_other": "{{count}} événements",
    "interruptTitle": "Arrêter coopérativement cet agent à sa prochaine étape (pas un kill de processus)",
    "interrupt": "⏸ Interrompre",
    "interrupting": "…",
    "loading": "Chargement de la session…",
    "done": "✓✓ terminé",
    "read": "✓ lu",
    "delivered": "⏳ livré",
    "agent": "Agent",
    "you": "Vous",
    "working": "{{name}} · en cours",
    "claude": "Claude",
    "priority": "Priorité",
    "placeholder": "{{label}} → cette session…",
    "send": "Envoyer",
    "sendHint": "⌘/Ctrl+Entrée pour envoyer · visible à la prochaine itération de l'agent",
    "msgType": {
      "steerLabel": "🔄 Orienter",
      "steerHint": "Ajuster le comportement en cours de tâche",
      "askLabel": "❓ Demander",
      "askHint": "Question — attend une réponse",
      "assignLabel": "📋 Assigner",
      "assignHint": "Une tâche à traiter",
      "noteLabel": "💬 Note",
      "noteHint": "Pour info, non urgent"
    },
    "sentRunning": "Livré — l'agent en cours le verra à sa prochaine étape",
    "sentIdle": "Livré — la cible est inactive ; apparaît dans sa boîte, lu à la prochaine exécution",
    "sentFailed": "Échec : {{error}}",
    "interruptReason": "L'opérateur a demandé l'arrêt depuis Fleet HQ",
    "interruptSent": "Interruption envoyée — l'agent s'arrête à la prochaine étape (pas un kill)",
    "interruptFailed": "Échec de l'interruption : {{error}}"
  },
  "sideEffects": {
    "empty": "Aucun effet de bord enregistré pour le moment.",
    "emptyHint": "Les commandes bash, installations de paquets et requêtes réseau apparaîtront ici.",
    "heading": "Effets de bord",
    "exportTitle": "Exporter les effets de bord filtrés en CSV",
    "all": "Tous",
    "colTime": "Heure",
    "colTool": "Outil",
    "colRisk": "Risque",
    "colDetail": "Détail",
    "colOutcome": "Résultat"
  },
  "monitor": {
    "elapsedHm": "il y a {{h}}h {{m}}m",
    "elapsedMs": "il y a {{m}}m {{s}}s",
    "elapsedS": "il y a {{s}}s",
    "heading": "Moniteur de flotte",
    "clientsHeading": "Clients connectés",
    "terminal": "Terminal",
    "webui": "UI Web",
    "repl": "REPL",
    "totalConnected": "connectés au total",
    "mailQueue": "File d'attente",
    "total": "Total",
    "open": "Ouverts",
    "unread": "Non lus",
    "agents": "Agents",
    "messagesSub": "messages",
    "uncompletedSub": "inachevés",
    "waitingSub": "en attente",
    "ofTotal": "sur {{count}} au total",
    "agentRoster": "Registre des agents",
    "liveMailActivity": "Activité mail en direct",
    "noActivity": "Aucune activité récente",
    "mailboxAgents": "Agents de la boîte",
    "noMailboxAgents": "Aucun agent enregistré",
    "moreCount": "+{{count}} de plus",
    "agentFallback": "agent",
    "fleetAgents": "Agents de la flotte",
    "noFleetAgents": "Aucun agent de flotte en cours",
    "iter": "itér.",
    "mailType": {
      "sent": "Envoyé",
      "delivered": "Livré",
      "read": "Lu",
      "completed": "Terminé"
    }
  },
  "sdd": {
    "status": {
      "pending": "en attente",
      "queued": "en file",
      "in_progress": "en cours",
      "blocked": "bloqué",
      "review": "revue",
      "failed": "échoué",
      "completed": "terminé",
      "cancelled": "annulé"
    },
    "activityHeading": "Activité",
    "feedEmpty": "Rien pour l'instant — les événements apparaissent ici à mesure que les agents prennent et terminent des tâches.",
    "destroyTitle": "Détruire le projet SDD ?",
    "destroyDesc": "Cela efface le run et son travail. Irréversible (le revert optionnel préserve l'historique).",
    "stopRun": "Arrêter le run",
    "stopRunAgents_one": "Arrêter le run ({{count}} agent actif)",
    "stopRunAgents_other": "Arrêter le run ({{count}} agents actifs)",
    "removeWorktreesAll": "Supprimer tous les worktrees git + branches wstack/ap/* — y compris le travail non fusionné",
    "removeWorktreesCount_one": "Supprimer {{count}} worktree git + branches wstack/ap/* — y compris le travail non fusionné",
    "removeWorktreesCount_other": "Supprimer {{count}} worktrees git + branches wstack/ap/* — y compris le travail non fusionné",
    "deleteArtifacts": "Supprimer tous les artefacts SDD (specs, graphe de tâches, board, session)",
    "revertMerged_one": "Revert aussi {{count}} commit fusionné",
    "revertMerged_other": "Revert aussi {{count}} commits fusionnés",
    "revertHint": "Ajoute des commits de revert (historique préservé). Refusé si l'arbre de travail est sale.",
    "baseBranchFallback": "la branche de base",
    "noteLeaveMerged": "Les commits fusionnés resteront sur la branche de base. Cochez la case ci-dessus pour les annuler aussi.",
    "noteAbandon": "Assurez-vous de vraiment vouloir abandonner ce run.",
    "destroying": "Destruction…",
    "destroyAll": "Tout détruire",
    "kanbanBacklog": "Backlog",
    "kanbanReady": "Prêt",
    "kanbanRunning": "En cours",
    "kanbanReview": "Revue",
    "kanbanFailed": "Échec",
    "kanbanDone": "Terminé",
    "kanbanEmpty": "vide"
  },
  "toolResult": {
    "collapseToLines": "Réduire aux {{count}} premières lignes",
    "showAllLines": "Afficher les {{total}} lignes ({{more}} de plus)",
    "exitCode": "code de sortie :",
    "jsonLines": "JSON · {{count}} lignes",
    "collapse": "réduire",
    "expand": "déplier"
  },
  "design": {
    "heading": "Design Studio — Galerie",
    "kitsCount": "{{count}} kits",
    "searchPlaceholder": "Rechercher des kits…",
    "stackTitle": "Stack pour Use + Materialize",
    "wrote": "{{path}} écrit",
    "materializeFailed": "Échec de matérialisation : {{error}}",
    "verifyError": "Vérifier : {{error}}",
    "verifyOffPalette": "Vérifier : {{pct}} % on-palette — {{count}} off-palette dans {{files}} fichier(s)",
    "verifyClean": "Vérifier : propre ✓ ({{files}} fichier(s) on-palette)",
    "writing": "Écriture du fichier de thème…",
    "scanning": "Analyse des fichiers UI…",
    "active": "Actif",
    "reapply": "Réappliquer",
    "use": "Utiliser",
    "materializeTitle": "Écrire les tokens dans un fichier de thème {{stack}}",
    "materialize": "Matérialiser",
    "verifyTitle": "Scanner les fichiers UI pour les couleurs hors palette",
    "verify": "Vérifier",
    "colors": "Couleurs"
  },
  "autoPhase": {
    "summary_one": "{{count}} phase · {{pct}} % terminé",
    "summary_other": "{{count}} phases · {{pct}} % terminé",
    "switchBoard": "Changer de tableau",
    "boardsCount_one": "{{count}} tableau…",
    "boardsCount_other": "{{count}} tableaux…",
    "toggleAutonomousTitle": "Basculer le mode autonome",
    "autonomous": "Autonome",
    "manual": "Manuel",
    "resumeTitle": "Reprendre l'exécution",
    "pauseTitle": "Mettre en pause",
    "resume": "Reprendre",
    "pause": "Pause",
    "stopTitle": "Arrêter l'exécution — annule les agents en cours immédiatement",
    "stop": "Arrêter",
    "newTitle": "Effacer ce tableau et démarrer une nouvelle exécution AutoPhase",
    "newLabel": "Nouveau",
    "revertConfirm": "Annuler les commits de l'exécution ?",
    "revertTitle": "Annuler cette exécution — git-revert des commits déposés et suppression des worktrees",
    "revert": "Annuler",
    "goal": "Objectif",
    "planning": "Planification des phases…",
    "planningBody": "Votre objectif a été reçu. WrongStack le décompose en phases et tâches — le tableau apparaît ici dès que le plan est prêt.",
    "startHeading": "Démarrer un plan de phases",
    "startBody": "Décrivez ce que vous voulez construire. WrongStack planifie les phases et tâches, puis les exécute — observez et pilotez l'exécution sur le tableau.",
    "startPlaceholder": "ex. Construire une API REST de gestion d'utilisateurs avec Express et SQLite...",
    "isolateLabel": "Isoler chaque phase dans son propre worktree git",
    "startButton": "Démarrer AutoPhase",
    "ctrlHint": "Ctrl+Entrée pour démarrer",
    "isolateOn": "les phases tournent dans des worktrees isolés, fusionnés en squash",
    "isolateOff": "les phases tournent directement sur la branche courante",
    "lanes": "Voies",
    "graph": "Graphe",
    "planningAck": "🚀 **AutoPhase** — compris. Je planifie les phases pour votre objectif…"
  },
  "collab": {
    "noObservers": "Aucun observateur en direct",
    "observerTitle": "Rejoindre comme observateur en lecture seule (Phase 1)",
    "observerRole": "observateur",
    "annotatorTitle": "Rejoindre comme annotateur — laisser des notes sur les appels d'outils (Phase 2)",
    "annotatorRole": "annotateur",
    "controllerTitle": "Rejoindre comme contrôleur — peut mettre en pause la boucle de l'agent (Phase 3)",
    "controllerRole": "contrôleur",
    "errorPrefix": "Collab : {{error}}",
    "dismiss": "ignorer",
    "observers_one": "{{count}} observateur",
    "observers_other": "{{count}} observateurs",
    "annotationsTitle": "{{count}} annotation(s) ouverte(s) — annotateurs en train de réviser",
    "notes_one": "{{count}} note",
    "notes_other": "{{count}} notes",
    "pausedTitle": "Boucle de l'agent en pause — un contrôleur révise",
    "paused": "en pause",
    "joinedTitle": "Rejoint {{time}}",
    "grantTitle": "Donner le contrôle — promouvoir ce participant au contrôleur",
    "injectTitle": "Injecter un résultat synthétique pour un appel d'outil en cours",
    "inject": "Injecter",
    "resumeTitle": "Reprendre la boucle de l'agent",
    "resume": "Reprendre",
    "pauseTitle": "Mettre en pause l'agent avant le prochain appel d'outil",
    "pauseAgent": "Mettre en pause l'agent",
    "leaveTitle": "Quitter la session d'observation",
    "leave": "Quitter",
    "injectToolResult": "Injecter un résultat d'outil",
    "close": "fermer",
    "targetTool": "id tool_use cible",
    "targetPlaceholder": "choisir un appel en cours ou saisir un id tool_use",
    "toolFallback": "outil",
    "noPendingTools": "Aucun appel d'outil en cours — saisissez un id tool_use ou mettez l'agent en pause d'abord.",
    "resultContent": "Contenu du résultat",
    "resultPlaceholder": "Résultat d'outil synthétique fourni à l'agent au lieu d'exécuter l'outil",
    "markError": "marquer comme erreur",
    "reasonPlaceholder": "raison (journal d'audit)",
    "queueInjection": "File d'injection",
    "controllerInjection": "injection contrôleur"
  },
  "connection": {
    "reconnecting": "Reconnexion au backend (tentative {{attempt}}) — nouvel essai dans {{remaining}} s",
    "disconnected": "Déconnecté du backend",
    "retry": "Réessayer",
    "retryTitle": "Réessayer la connexion maintenant",
    "dismissTitle": "Ignorer (la puce dans la barre supérieure affiche toujours le statut)"
  },
  "mode": {
    "modePrefix": "mode :",
    "activeTitle": "Mode actif",
    "heading": "Mode",
    "defaultName": "Par défaut",
    "defaultDesc": "Comportement standard de l'agent"
  },
  "cost": {
    "clickTitle": "Cliquez pour la répartition des coûts par tour",
    "heading": "Répartition des coûts",
    "noPricing": "Aucune tarification pour le modèle actuel — les valeurs de coût sont nulles.",
    "noTurns": "Aucun tour terminé pour le moment. Lancez un prompt pour voir le coût par tour ici.",
    "topExpensive_one": "Tour le plus cher",
    "topExpensive_other": "Les {{count}} tours les plus chers"
  },
  "model": {
    "runDefault": "Par défaut du run",
    "useRunDefault": "Utiliser le défaut du run",
    "filterPlaceholder": "Filtrer les modèles…",
    "loading": "Chargement des modèles…",
    "noMatch": "Aucune correspondance"
  },
  "modelSwitcher": {
    "filterPlaceholder": "Filtrer les fournisseurs et modèles…",
    "noSavedProviders": "Aucun fournisseur enregistré — enregistrez d'abord une clé dans les Paramètres.",
    "active": "actif"
  },
  "work": {
    "todos": "À faire",
    "tasks": "Tâches",
    "plan": "Plan"
  },
  "todos": {
    "toggleAria": "Basculer : {{content}}",
    "removeTitle": "Supprimer la tâche",
    "removeAria": "Supprimer « {{content}} »",
    "completedCount_one": "{{count}} terminée",
    "completedCount_other": "{{count}} terminées"
  },
  "task": {
    "start": "Démarrer",
    "complete": "Terminer",
    "retry": "Réessayer",
    "assign": "Affecter",
    "assignTitle": "Affecter un agent",
    "unassigned": "Non affecté",
    "statusPending": "En attente",
    "statusInProgress": "En cours",
    "statusBlocked": "Bloqué",
    "statusFailed": "Échec",
    "statusReview": "Revue",
    "statusDone": "Terminé",
    "startTitle": "Démarrer",
    "completeTitle": "Terminer",
    "fail": "Échouer",
    "failTitle": "Marquer comme échoué",
    "boardCount": "{{total}} tâches · {{done}} terminées"
  },
  "toolGroup": {
    "toolCalls_one": "{{count}} appel d'outil",
    "toolCalls_other": "{{count}} appels d'outil"
  },
  "fileRef": {
    "removeTitle": "Supprimer la référence",
    "linesCount_one": "{{count}} ligne",
    "linesCount_other": "{{count}} lignes"
  },
  "plan": {
    "statusOpen": "Ouvert",
    "statusInProgress": "En cours",
    "statusDone": "Terminé",
    "startTitle": "Démarrer",
    "doneTitle": "Marquer comme terminé",
    "reopenTitle": "Rouvrir",
    "reopen": "Rouvrir"
  },
  "filePicker": {
    "heading": "@ Fichiers",
    "noMatch": "Aucun fichier ne correspond à « {{query}} »",
    "searching": "Recherche dans le projet…"
  },
  "toast": {
    "dismiss": "Ignorer"
  },
  "search": {
    "placeholder": "Rechercher dans le chat…",
    "prevHit": "Résultat précédent",
    "nextHit": "Résultat suivant",
    "close": "Fermer (Esc)"
  },
  "phase": {
    "statusPending": "En attente",
    "statusReady": "Prêt",
    "statusRunning": "En cours",
    "statusPaused": "En pause",
    "statusCompleted": "Terminé",
    "statusFailed": "Échec",
    "statusSkipped": "Ignoré",
    "heading": "Phases",
    "autonomousOn": "● Autonome",
    "autonomousOff": "○ Manuel",
    "autonomousOnTitle": "Mode autonome actif — cliquer pour mettre en pause",
    "autonomousOffTitle": "Mode manuel — cliquer pour activer l'autonome",
    "overallProgress": "Progression globale",
    "tasksSuffix": "{{done}}/{{total}} tâches",
    "agentsSuffix_one": "{{count}} agent",
    "agentsSuffix_other": "{{count}} agents"
  },
  "ctxMode": {
    "triggerTitle": "Mode de fenêtre de contexte",
    "ctxPrefix": "ctx :",
    "opsHeading": "Opérations de contexte",
    "compactNow": "Compacter maintenant",
    "compactNowDesc": "Élider les anciennes sorties d'outil",
    "compactAggressive": "Compaction agressive",
    "compactAggressiveDesc": "Élision maximale maintenant",
    "repairContext": "Réparer le contexte",
    "repairDesc": "Corriger les blocs tool-use orphelins",
    "debugContext": "Déboguer le contexte",
    "debugDesc": "Répartition de la taille par section",
    "windowHeading": "Fenêtre de contexte",
    "keepElide": "garder {{k}} récents · élider {{t}}+ jetons",
    "fallbackName": "Équilibré",
    "fallbackDesc": "Compaction roulante par défaut"
  },
  "transcript": {
    "kindAssistant": "Assistant",
    "kindThinking": "Réflexion",
    "kindToolCall": "Appel d'outil",
    "kindToolResult": "Résultat d'outil",
    "kindError": "Erreur",
    "kindStatus": "Statut",
    "kindSystem": "Système",
    "title": "Historique du chat",
    "copyTitle": "Copier l'historique du chat de l'agent",
    "empty": "Pas encore d'historique de chat pour cet agent."
  },
  "autonomy": {
    "heading": "Mode d'autonomie",
    "titlePrefix": "Autonomie : {{label}}",
    "descOff": "Contrôle manuel total — l'agent attend votre saisie.",
    "descSuggest": "L'agent suggère les prochaines étapes mais attend une approbation.",
    "descAuto": "L'agent continue automatiquement après un bref délai de confirmation.",
    "descEternal": "L'agent fonctionne de façon autonome jusqu'à la fin de l'objectif.",
    "descEternalParallel": "Exécution autonome multi-agents — mode flotte."
  },
  "queue": {
    "heading": "File d'attente des messages",
    "subtitle": "{{count}} en file · messages envoyés avant la fin de l'agent",
    "btwTitle": "Au passage — envoyé en suivi sans interrompre l'agent en cours",
    "steerTitle": "Piloter — interrompt l'agent en cours et le redirige avec ce message",
    "queueTitle": "En file — retenu jusqu'à la fin du run de l'agent, puis envoyé dans l'ordre",
    "sortNewestTitle": "Trié du plus récent — cliquer pour trier du plus ancien",
    "sortOldestTitle": "Trié du plus ancien — cliquer pour trier du plus récent",
    "newest": "Plus récent",
    "oldest": "Plus ancien",
    "clear": "Vider",
    "clearTitle": "Effacer tous les messages en file",
    "closeTitle": "Fermer",
    "emptyTitle": "La file est vide",
    "emptyBody": "Utilisez les boutons btw / steer / ajouter à la file à côté de l'entrée pour ajouter des messages. Les éléments en file sont envoyés dans l'ordre à la fin du run de l'agent.",
    "removeTitle": "Retirer de la file",
    "footer": "Les messages sont envoyés dans l'ordre d'arrivée à la fin du run de l'agent. Utilisez le tri pour voir les plus récents d'abord."
  },
  "checkpoint": {
    "heading": "Points de contrôle de session",
    "countSuffix_one": "{{count}} point de contrôle",
    "countSuffix_other": "{{count}} points de contrôle",
    "description": "Rembobiner la session à n'importe quel point de contrôle. Les messages et modifications de fichiers reviennent à ce point — le LLM continue comme si rien ne s'était passé après.",
    "emptyTitle": "Pas encore de points de contrôle",
    "emptyBody": "Les points de contrôle sont créés automatiquement à chaque message envoyé. Envoyez quelques messages et revenez.",
    "latest": "récent",
    "msgSuffix_one": "{{count}} msg",
    "msgSuffix_other": "{{count}} msgs",
    "footerPre": "Cliquer un point de contrôle pour rembobiner",
    "footerPost": "pour fermer"
  },
  "goal": {
    "statusActive": "Actif",
    "statusPaused": "En pause",
    "statusDone": "Terminé",
    "statusFailed": "Échec",
    "statusAbandoned": "Abandonné",
    "heading": "Objectif",
    "refined": "Raffiné",
    "progress": "Progression",
    "iterations": "itérations",
    "deliverables": "Livrables",
    "recentActivity": "Activité récente"
  },
  "worktree": {
    "cleanTitle_one": "Nettoyer {{count}} worktree orphelin ?",
    "cleanTitle_other": "Nettoyer {{count}} worktrees orphelins ?",
    "cleanMessage": "Supprime forcément chaque worktree git + branche wstack/ap laissé par des runs précédents. Le travail non fusionné dedans est perdu.",
    "cleanConfirm": "Nettoyer les orphelins",
    "orphanCount_one": "{{count}} worktree orphelin de runs précédents",
    "orphanCount_other": "{{count}} worktrees orphelins de runs précédents",
    "andMore": "…et {{count}} de plus",
    "cleanButtonTitle": "Supprimer forcément tous les worktrees + branches orphelins",
    "removed_one": "✓ {{count}} worktree orphelin supprimé.",
    "removed_other": "✓ {{count}} worktrees orphelins supprimés.",
    "cleanupFailed": "échec du nettoyage",
    "lanesHeading": "Worktrees",
    "base": "base",
    "isolatedCount_one": "{{count}} isolé",
    "isolatedCount_other": "{{count}} isolés",
    "statusAllocating": "allocation",
    "statusActive": "actif",
    "statusCommitting": "commit",
    "statusMerging": "fusion",
    "statusMerged": "fusionné",
    "statusConflict": "conflit",
    "statusFailed": "échec",
    "conflictBadge": "CONFLIT",
    "graphAria": "Graphe de branches worktree à partir de {{base}}",
    "mergedLabel": "✓ fusionné → {{base}}"
  },
  "process": {
    "heading": "Processus en cours",
    "subtitle": "{{active}} actifs · {{total}} total",
    "killAll": "Tout tuer",
    "emptyTitle": "Aucun processus suivi",
    "emptyBody": "Les processus apparaissent ici quand l'agent lance des outils bash ou exec. Les processus actifs affichent une LED pulsante.",
    "pidLabel": "PID {{pid}}",
    "protected": "protégé",
    "protectedTitle": "Protégé — survit à kill/killAll",
    "killTitle": "Tuer PID {{pid}}"
  },
  "diff": {
    "tooLarge": "Diff omis (fichier trop volumineux pour un rendu en ligne)."
  },
  "fallback": {
    "placeholder": "Ajouter un modèle de repli…",
    "emptyHint": "Essayés dans l'ordre quand le modèle principal est limité ou bloqué.",
    "moveUp": "Monter",
    "moveDown": "Descendre",
    "manualPlaceholder": "fournisseur/modèle",
    "addTitle": "Ajouter une référence de modèle"
  },
  "liveSessions": {
    "loading": "Chargement des sessions...",
    "apiUnavailable": "API de session indisponible :",
    "empty": "Aucune session en direct. Ouvrez une autre instance wstack pour la voir ici.",
    "heading": "Sessions en direct ({{count}})",
    "autoRefresh": "actualisation toutes les 5 s",
    "pidLabel": "PID {{pid}}",
    "agentMeta": "{{iter}} itér · {{tools}} outils · {{ago}}",
    "andMore": "... et {{count}} de plus",
    "noAgents": "Aucun agent"
  },
  "monacoDiff": {
    "applyTitle": "Écrire la version modifiée sur le disque",
    "applying": "Application…",
    "applied": "Appliqué",
    "apply": "Appliquer"
  },
  "errorBody": {
    "showStack_one": "Afficher la trace de pile ({{count}} cadre)",
    "showStack_other": "Afficher la trace de pile ({{count}} cadres)",
    "hideStack_one": "Masquer la trace de pile ({{count}} cadre)",
    "hideStack_other": "Masquer la trace de pile ({{count}} cadres)"
  },
  "officeMap": {
    "liveHeading": "Live",
    "clients": "Clients",
    "agents": "Agents",
    "model": "Modèle",
    "mode": "Mode",
    "toolCalls": "Appels d'outils",
    "displayHeading": "Affichage",
    "statsHud": "HUD stats",
    "legends": "Légendes",
    "minimap": "Minicarte",
    "zoomControls": "Contrôles zoom",
    "animateWires": "Animer les fils",
    "backgroundHeading": "Arrière-plan",
    "bgDots": "Points",
    "bgLines": "Lignes",
    "bgCross": "Croix",
    "bgNone": "Aucun"
  },
  "toolInput": {
    "noParams": "(aucun paramètre)",
    "itemCount_one": "{{count}} élément",
    "itemCount_other": "{{count}} éléments",
    "keyCount_one": "{{count}} clé",
    "keyCount_other": "{{count}} clés"
  },
  "message": {
    "roleYou": "Vous",
    "roleTool": "Outil",
    "roleThinking": "Réflexion",
    "roleAssistant": "Assistant",
    "inputLabel": "Entrée",
    "downloadTitle": "Télécharger comme fichier",
    "empty": "(vide)",
    "hideDetails": "Masquer les détails",
    "showDetails": "Afficher les détails",
    "showDetailsLines_one": "Afficher les détails ({{count}} ligne)",
    "showDetailsLines_other": "Afficher les détails ({{count}} lignes)",
    "editHint": "⌘/Ctrl+Entrée pour enregistrer · Échap pour annuler",
    "saveResend": "Enregistrer et renvoyer",
    "thinkingProcess": "Processus de réflexion",
    "thinkingMeta": "itér {{iter}} · {{dur}} · {{lines}}",
    "replay": "relecture",
    "linesSuffix_one": "{{count}} ligne",
    "linesSuffix_other": "{{count}} lignes",
    "copyLog": "Copier le journal",
    "showFullLog": "Afficher le journal complet",
    "typing": "Écrit…",
    "noContent": "Aucun contenu",
    "failedToSend": "⚠ Échec de l'envoi",
    "autoPaused": "⚠️ _Avance auto en pause — nombre maximum de tours automatiques consécutifs atteint. Saisissez quelque chose pour continuer (l'autonomie reste activée)._",
    "rsIterations": "Itérations : {{n}}",
    "rsTools": "Appels d'outils : {{n}}",
    "rsElapsed": "Écoulé : {{s}}",
    "rsCost": "Coût : {{c}}",
    "useInput": "Entrée : {{n}}",
    "useOutput": "Sortie : {{n}}",
    "useCacheRead": "Lecture cache : {{n}}",
    "useCost": "Coût : {{c}}",
    "renderedLabel": "Rendu",
    "rawLabel": "Brut",
    "showRenderedTitle": "Afficher le markdown rendu",
    "showRawTitle": "Afficher la source markdown brute",
    "editTitle": "Modifier et renvoyer ce prompt",
    "editLabel": "Modifier",
    "unpinTitle": "Détacher",
    "pinTitle": "Épingler cette réponse",
    "pinnedLabel": "Épinglé",
    "pinLabel": "Épingler",
    "regenerateTitle": "Régénérer cette réponse",
    "retryLabel": "Réessayer"
  },
  "watch": {
    "toolFallback": "outil",
    "toolFailed": "Outil échoué"
  },
  "shortcuts": {
    "heading": "Raccourcis clavier",
    "footerPre": "Appuyez sur",
    "footerPost": "à tout moment pour rouvrir cette liste.",
    "sectionGlobal": "Global",
    "sectionTuiParity": "Parité panneau TUI",
    "sectionFleet": "Flotte & Agents",
    "sectionChatInput": "Saisie du chat",
    "sectionChat": "Chat",
    "sectionChatNav": "Navigation du chat (hors saisie)",
    "dCommandPalette": "Ouvrir la palette de commandes",
    "dShowOverlay": "Afficher cette overlay de raccourcis",
    "dToggleSidebar": "Basculer la barre latérale",
    "dOpenPanel": "Ouvrir le panneau latéral (Session, Agents, Historique, Fichiers, Changes, Messagerie, Compétences, Office Map)",
    "dDesignStudio": "Ouvrir le panneau Design Studio",
    "dWorktrees": "Ouvrir le panneau Worktrees",
    "dFocusInput": "Focaliser la saisie du message",
    "dSessionPanel": "Panneau de session",
    "dFleetOverlay": "Overlay moniteur de flotte",
    "dAgentsOverlay": "Overlay moniteur d'agents",
    "dWorktreeMonitor": "Moniteur de worktrees",
    "dPlanPanel": "Panneau plan",
    "dTodosPanel": "Panneau todos",
    "dQueuePanel": "Panneau file",
    "dProcessMonitor": "Moniteur de processus",
    "dGoalPanel": "Panneau objectif",
    "dSessionsDashboard": "Tableau des sessions",
    "dOfficeMap": "Office map du coordinateur",
    "dDockPicker": "Sélecteur de puces du dock",
    "dOpenFleet": "Ouvrir l'overlay moniteur de flotte",
    "dOpenAgents": "Ouvrir l'overlay moniteur d'agents",
    "dNavigateAgents": "Naviguer parmi les agents",
    "dSelectAgent": "Sélectionner l'agent focalisé",
    "dCloseOverlay": "Fermer l'overlay actif",
    "dSendMessage": "Envoyer le message",
    "dNewline": "Insérer un saut de ligne",
    "dRecallPrev": "Rappeler le prompt précédent (entrée vide)",
    "dRecallNext": "Rappeler le prompt suivant",
    "dSlashPopup": "Ouvrir le popup de commandes slash",
    "dAutocomplete": "Auto-compléter la commande surlignée",
    "dDismissPopup": "Fermer le popup / vider l'entrée",
    "dSearchChat": "Rechercher dans le chat actuel",
    "dClearContext": "Vider le contexte (comme /clear)",
    "dNewSession": "Démarrer une nouvelle session (comme /new)",
    "dExportMarkdown": "Exporter le chat en markdown",
    "dModelSwitcher": "Overlay sélecteur de modèle rapide",
    "dCompactDensity": "Basculer la densité UI compacte",
    "dAbortRun": "Abandonner le run en cours (pendant l'exécution)",
    "dFocusNext": "Focaliser le message suivant (alias : ↓)",
    "dFocusPrev": "Focaliser le message précédent (alias : ↑)",
    "dJumpFirst": "Aller au premier message",
    "dJumpLast": "Aller au dernier message",
    "dCopyFocused": "Copier le texte du message focalisé",
    "dClearFocused": "Effacer le message focalisé"
  },
  "sddBoard": {
    "titleFallback": "Tableau SDD en direct",
    "defaultModelTitle": "Modèle worker par défaut au niveau du run (les overrides par tâche priment)",
    "graphLabel": "Graphe",
    "kanbanLabel": "Kanban",
    "retryAllTitle": "Remettre chaque tâche échouée en pending",
    "retryFailed": "Réessayer échouées ({{count}})",
    "resume": "Reprendre",
    "pause": "Pause",
    "stop": "Arrêter",
    "cleanTitle": "Supprimer les worktrees git + branches wstack/ap du run",
    "cleanWorktrees": "Nettoyer worktrees",
    "rollbackTitle": "Revert {{count}} commit(s) fusionné(s) sur {{base}}",
    "rollback": "Rollback ({{count}})",
    "stopping": "Arrêt…",
    "destroying": "Destruction…",
    "destroyTitle": "Arrêter, supprimer tous les worktrees, revert optionnel des commits fusionnés et supprimer le projet SDD",
    "destroy": "Détruire",
    "statDone": "faits",
    "statRunning": "en cours",
    "statFailed": "échec",
    "statWave": "vague",
    "statElapsed": "écoulé",
    "noActiveWorkers": "aucun worker actif",
    "deadlock": "Impasse — tâches bloquées par un travail échoué :",
    "noRunTitle": "Aucun run SDD actif.",
    "noRunBody": "Démarrez-en un via l'assistant New SDD Project ou /sdd execute dans la CLI — les agents apparaissent ici en direct, chacun dans un worktree isolé.",
    "clickTaskHint": "cliquer une tâche pour les détails",
    "lcClean": "Nettoyage",
    "lcRollback": "Rollback",
    "lcDestroy": "Destruction",
    "lcFailed": "{{op}} échoué : {{reason}}",
    "lcUnknownError": "erreur inconnue",
    "lcWorktrees_one": "{{count}} worktree supprimé",
    "lcWorktrees_other": "{{count}} worktrees supprimés",
    "lcCommits_one": "{{count}} commit reverti",
    "lcCommits_other": "{{count}} commits revertis",
    "lcDeleted": "supprimé {{items}}",
    "lcNothing": "rien à faire",
    "lcNote": "{{op}} : {{body}} — note : {{reason}}",
    "lcOk": "{{op}} : {{body}}"
  },
  "sddTask": {
    "backTitle": "Retour à l'activité",
    "workingOn": "travaille sur cette tâche",
    "assigned": "assigné",
    "metaPriority": "Priorité",
    "metaType": "Type",
    "metaDuration": "Durée",
    "metaElapsed": "Écoulé",
    "metaRetries": "Tentatives",
    "metaWorktree": "Worktree",
    "workerModel": "Modèle worker",
    "runDefault": "défaut du run : {{model}}",
    "runDefaultPlaceholder": "Défaut du run",
    "runDefaultPlaceholderModel": "Défaut du run ({{model}})",
    "verificationCmd": "Commande de vérification",
    "gatesCompletion": "valide la complétion (exit 0)",
    "verifyPlaceholder": "ex. pnpm vitest run path/to/file",
    "addVerify": "+ Ajouter une commande de vérification",
    "description": "Description",
    "timeline": "Chronologie",
    "dependsOn": "Dépend de",
    "blocks": "Bloque",
    "newWorkerPlaceholder": "Nom du nouveau worker…",
    "confirmStop": "Arrêter cette tâche en cours ?",
    "confirmDelete": "Supprimer cette tâche du run ?",
    "retryTitle": "Remettre cette tâche en pending",
    "reassign": "Réassigner",
    "stopTitle": "Abandonner le worker sur cette tâche",
    "splitTitle": "Diviser cette tâche en sous-tâches confiées à des workers séparés",
    "split": "Diviser",
    "splitHint": "Une sous-tâche par ligne — Titre :: description (description facultative)",
    "splitPlaceholder": "Écrire la couche données :: ajouter le dépôt\nCâbler l'UI",
    "splitInto": "Diviser en sous-tâches",
    "deleteTitle": "Retirer cette tâche non démarrée du run"
  },
  "sddWizard": {
    "phaseStart": "Démarrer",
    "phaseInterview": "Entretien",
    "phaseSpecReview": "Revue spec",
    "phasePlanning": "Planification",
    "phaseTaskReview": "Revue tâches",
    "phaseRunning": "En cours",
    "phaseDone": "Terminé",
    "titleFallback": "Nouveau projet SDD",
    "questionsSuffix": "{{cur}}/{{max}} questions",
    "tasksSuffix": "{{count}} tâches",
    "runCfgTitle": "Config du run — modèle par défaut + chaîne de repli",
    "modelsLabel": "Modèles",
    "startRun": "Démarrer le run",
    "defaultWorkerModel": "Modèle worker par défaut",
    "leaderDefaultPlaceholder": "Leader / défaut de session",
    "useSessionDefault": "Utiliser le défaut de session",
    "fallbackChain": "Chaîne de repli",
    "appliesToAll": "S'applique à chaque tâche. Override par tâche depuis le board live après le démarrage.",
    "parallelAgents": "Agents parallèles",
    "isolateWorktrees": "Isoler dans des worktrees git",
    "worktreeOn": "Chaque tâche tourne dans son propre worktree, squash-mergé à la fin.",
    "worktreeOff": "Les tâches tournent directement sur la branche courante (pas d'isolation).",
    "goalPrompt": "Que voulez-vous construire ?",
    "goalPlaceholder": "ex. Ajouter un login OAuth (Google + GitHub) avec gestion de session",
    "startingInterview": "Démarrage de l'entretien…",
    "startInterview": "Démarrer l'entretien",
    "introBody": "Un agent isolé vous interviewe pour bâtir une spec, la décompose en un graphe de tâches ordonné par dépendances, puis une vraie flotte multi-agents l'exécute — à suivre en direct sur le board.",
    "taskGraphSummary": "Graphe de tâches · {{count}} tâches, ordonné par dépendances",
    "dragToExplore": "glisser pour explorer",
    "show": "afficher",
    "goalLabel": "Objectif",
    "implementationPlan": "Plan d'implémentation",
    "approveSpec": "Approuver la spec → planifier l'implémentation",
    "approveTasks": "Approuver les tâches",
    "approvePlan": "Approuver le plan",
    "answerPlaceholder": "Répondre à la question…",
    "changePlaceholder": "Demander un changement…"
  },
  "fileExplorer": {
    "emptyDir": "vide",
    "loadFailed": "Échec du chargement des fichiers : {{error}}",
    "expandAllTitle": "Déplier tous les dossiers",
    "expandAll": "Tout déplier",
    "collapseAllTitle": "Replier tous les dossiers",
    "collapse": "Replier",
    "folders_one": "{{count}} dossier",
    "folders_other": "{{count}} dossiers",
    "currentDirTitle": "Dossier courant : {{path}}",
    "navigateToTitle": "Aller à {{path}}",
    "filesSuffix_one": "{{count}} fichier",
    "filesSuffix_other": "{{count}} fichiers",
    "goToDir": "aller au dossier",
    "navigateParentTitle": "Aller au dossier parent de {{path}}",
    "parentDirectory": "dossier parent",
    "noFiles": "Aucun fichier trouvé",
    "copyAbsPath": "Copier le chemin absolu",
    "copyRelPath": "Copier le chemin relatif",
    "openInTerminal": "Ouvrir dans le terminal",
    "openInFileManager": "Ouvrir dans le gestionnaire de fichiers",
    "mentionInChat": "Mentionner dans le chat",
    "copyPath": "Copier le chemin"
  },
  "codeEditor": {
    "sendSelectionAction": "Envoyer la sélection au chat",
    "noFilesOpen": "Aucun fichier ouvert",
    "selectToEdit": "Sélectionnez un fichier dans l'explorateur pour éditer",
    "sendSelectedTitle": "Envoyer les lignes sélectionnées au chat",
    "mentionFileTitle": "Mentionner ce fichier dans le chat",
    "sendToChat": "Envoyer au chat",
    "mentionFile": "Mentionner le fichier",
    "loadingEditor": "Chargement de l'éditeur…",
    "selectTab": "Sélectionnez un onglet pour voir son contenu"
  },
  "analytics": {
    "loading": "Chargement des analytics…",
    "heading": "Tableau Analytics",
    "autoRefresh": "actualisation toutes les 10 s",
    "liveSessions": "Sessions en direct",
    "agents": "Agents",
    "agentsActive": "{{count}} actifs",
    "totalEvents": "Événements totaux",
    "categoriesSub": "{{count}} catégories",
    "toolCalls": "Appels d'outils",
    "iterationsSub": "{{count}} itérations",
    "sessionCost": "Coût de session",
    "tokensSub": "{{input}} entrée / {{output}} sortie",
    "sessionDuration": "Durée de session",
    "messagesSub": "{{count}} messages",
    "eventsByCategory": "Événements par catégorie",
    "noEvents": "Aucun événement enregistré.",
    "topEvents": "Top événements",
    "activeSessionUsage": "Utilisation session active",
    "provider": "Fournisseur",
    "model": "Modèle",
    "inputTokens": "Jetons d'entrée",
    "outputTokens": "Jetons de sortie",
    "cacheRatio": "Ratio cache",
    "filesRead": "Fichiers lus",
    "noSession": "Aucune session active ou en attente de données…",
    "healthErrors": "Santé & erreurs",
    "errorEvents": "Événements d'erreur",
    "warningEvents": "Événements d'avertissement",
    "cacheHitRate": "Taux de hit cache",
    "totalCategories": "Catégories totales",
    "waitingData": "En attente de données…",
    "recentEvents": "Événements récents",
    "noRecentEvents": "Aucun événement récent. Interagissez avec l'UI pour générer des événements."
  },
  "promptLib": {
    "searchPlaceholder": "Rechercher des prompts…",
    "newPrompt": "＋ Nouveau prompt",
    "all": "Tous",
    "recent": "🕘 Récents",
    "favorites": "★ Favoris",
    "noMatch": "Aucun prompt ne correspond.",
    "newPromptHeading": "Nouveau prompt",
    "titlePlaceholder": "Titre *",
    "descPlaceholder": "Description sur une ligne",
    "categoryPlaceholder": "Catégorie",
    "tagsPlaceholder": "tags, séparés, par virgule",
    "contentPlaceholder": "Contenu du prompt * — {{name}} pour les variables",
    "variables": "Variables",
    "addVar": "＋ var",
    "varNamePlaceholder": "nom",
    "varDescPlaceholder": "description",
    "removeVarTitle": "Supprimer la variable",
    "required": "requis",
    "multiline": "multiligne",
    "enumPlaceholder": "enum : a, b, c",
    "savePrompt": "Enregistrer le prompt",
    "saveFailed": "Impossible d'enregistrer le prompt.",
    "titleContentRequired": "Le titre et le contenu sont requis.",
    "toggleFavoriteTitle": "Basculer le favori",
    "selectOption": "— choisir —",
    "fillMissing": "Remplir : {{missing}}",
    "insertIntoChat": "Insérer dans le chat",
    "selectPromptHint": "Sélectionnez un prompt pour prévisualiser et insérer."
  },
  "skillDetail": {
    "scopeProject": "Projet",
    "scopeGlobal": "Global",
    "scopeBundled": "Intégré",
    "timeoutError": "Délai de la requête dépassé. Veuillez réessayer.",
    "updateFailed": "Mise à jour échouée",
    "saveFailed": "Échec de l'enregistrement",
    "uninstallFailed": "Désinstallation échouée",
    "noSkillSelected": "Aucune compétence sélectionnée",
    "selectSkillHint": "Sélectionnez une compétence dans la barre latérale pour voir sa doc",
    "goToChat": "Aller au chat",
    "openSourceRepo": "Ouvrir le dépôt source",
    "copySourceUrl": "Copier l'URL source",
    "updatedLabel": "↑ Mis à jour : {{list}}",
    "upToDateLabel": "— À jour : {{list}}",
    "errorsLabel": "✗ {{list}}",
    "checkUpdatesTitle": "Vérifier les mises à jour",
    "exportTitle": "Exporter la compétence en .md",
    "editTitle": "Modifier la compétence",
    "uninstallTitle": "Désinstaller la compétence",
    "closeTitle": "Fermer et aller au chat",
    "backTitle": "Reculer",
    "forwardTitle": "Avancer",
    "relatedFiles": "Fichiers liés",
    "references": "Références",
    "goToSkillTitle": "Aller à {{name}}",
    "loadingContent": "Chargement du contenu…",
    "editingLabel": "Modification de {{name}}",
    "editStats": "{{lines}} lignes · {{words}} mots · {{chars}} caractères",
    "charsWarningFmt": "⚠ {{used}} Mo / {{limit}} Mo",
    "draftSaved": "Brouillon enregistré",
    "draftRestored": "Brouillon restauré",
    "discardDraft": "Supprimer le brouillon",
    "splitViewTitle": "Vue scindée",
    "hidePreviewTitle": "Masquer l'aperçu",
    "contentPlaceholder": "Contenu de la compétence (markdown)...",
    "loadFailed": "Échec du chargement du contenu",
    "noContent": "Aucun contenu disponible",
    "uninstallSkillHeading": "Désinstaller la compétence",
    "uninstallConfirm": "Désinstaller {{name}} ?",
    "uninstallRemovePath": "Cela supprimera la compétence de {{path}} et est irréversible.",
    "uninstallAction": "Désinstaller"
  },
  "office": {
    "sessionStats": "Stats de session",
    "clients": "Clients",
    "input": "Entrée",
    "output": "Sortie",
    "cost": "Coût",
    "agentsSuffix": "agents",
    "upPrefix": "depuis {{time}}",
    "webuiClient": "Client WebUI",
    "disconnected": "Déconnecté",
    "connected": "Connecté",
    "tuiClient": "Client TUI",
    "terminal": "Terminal",
    "repl": "REPL",
    "coordinator": "COORDINATEUR",
    "fleetSummary": "Résumé de la flotte",
    "toolCallsLabel": "Appels d'outils",
    "tokensLabel": "Jetons",
    "coordinatingFleet": "Coordonne la flotte",
    "donePrefix": "✓ terminé ·",
    "failedPrefix": "✕ échec ·",
    "seenPrefix": "vu il y a {{time}}",
    "availableDesk": "Bureau libre",
    "mailboxHub": "Centre de messagerie",
    "unreadSuffix_one": "{{count}} non lu",
    "unreadSuffix_other": "{{count}} non lus",
    "allClear": "Tout est lu",
    "total": "Total",
    "unreadLabel": "Non lus",
    "liveActivity": "Activité en direct",
    "waitingActivity": "En attente d'activité…",
    "now": "maintenant",
    "fleetHq": "QG de flotte WrongStack",
    "live": "EN DIRECT",
    "legendStatus": "Statut",
    "legendActive": "Actif",
    "legendIdle": "Inactif",
    "legendError": "Erreur",
    "legendConnections": "Connexions",
    "legendMail": "Mail",
    "legendTask": "Tâche",
    "legendStatusConn": "Statut",
    "arrange": "Réorganiser",
    "arrangeTitle": "Repositionner les nœuds sur le plan",
    "feed": "Flux",
    "feedTitle": "Basculer le flux d'activité en direct",
    "broadcast": "Diffuser",
    "broadcastTitle": "Diffuser un message à chaque session live du projet",
    "broadcastToAll": "Diffuser à toutes les sessions",
    "broadcastPlaceholder": "Message à chaque agent live du projet…",
    "broadcastSendHint": "⌘/Ctrl+Entrée pour envoyer",
    "openFullView": "Ouvrir la vue complète des opérations",
    "rowStatus": "Statut",
    "rowModel": "Modèle",
    "rowTool": "Outil",
    "rowIterations": "Itérations",
    "rowToolCalls": "Appels d'outils",
    "rowTokensIn": "Jetons entrants",
    "rowTokensOut": "Jetons sortants",
    "rowTokensTotal": "Jetons totaux",
    "rowContext": "Contexte",
    "rowCost": "Coût",
    "rowLastSeen": "Dernière vue",
    "rowSurface": "Surface",
    "rowBranch": "Branche",
    "rowPid": "PID",
    "rowDir": "Rép.",
    "rowAgents": "Agents",
    "rowUptime": "Disponibilité",
    "rowConnections": "Connexions",
    "rowTotalMessages": "Messages totaux",
    "rowUnread": "Non lus",
    "recent": "Récents",
    "noSubject": "(sans objet)",
    "fullOperationStream": "Flux complet des opérations",
    "closeEsc": "Fermer (Échap)",
    "idleDesk": "Bureau inactif",
    "fleetHqLabel": "QG de flotte",
    "clientsSuffix_one": "{{count}} client",
    "clientsSuffix_other": "{{count}} clients",
    "taskFallback": "tâche",
    "controlLabel": "contrôle"
  },
  "skillsList": {
    "installTitle": "Installer une compétence",
    "createTitle": "Créer une compétence",
    "exportTitle": "Exporter toutes les compétences en .zip",
    "checkUpdatesTitle": "Vérifier les mises à jour (toutes)",
    "searchPlaceholder": "Rechercher des compétences…",
    "loading": "Chargement…",
    "noSkills": "Aucune compétence installée",
    "noMatch": "Aucune compétence ne correspond au filtre",
    "noDescription": "Aucune description",
    "scopeForeign": "Externe",
    "installHeading": "Installer la Compétence",
    "installHint": "Entrez une référence de dépôt GitHub (owner/repo) ou une URL complète.",
    "installPlaceholder": "ex. wrongstack/skill-name ou https://github.com/owner/repo",
    "installScope": "Portée d'installation :",
    "installBtn": "Installer",
    "installedMsg": "Installée : {{names}}",
    "installFailed": "Échec de l'installation",
    "createHeading": "Créer une Compétence",
    "createHint": "Scaffold une nouvelle compétence. La première ligne est le déclencheur.",
    "nameLabel": "Nom",
    "namePlaceholder": "ex. ma-nouvelle-compétence",
    "descLabel": "Description / Déclencheur",
    "descPlaceholder": "Utiliser cette compétence quand <situation>.\nDéclencheurs : l'utilisateur dit \"mot-clé\", \"autre\".",
    "saveIn": "Enregistrer dans :",
    "createBtn": "Créer la Compétence",
    "createdMsg": "Créée : {{name}}",
    "createFailed": "Échec de la création"
  },
  "timeline": {
    "noEvents": "Aucun événement."
  },
  "designStudio": {
    "pickHint": "Choisir un kit — l'agent s'y conformera.",
    "gallery": "Galerie",
    "galleryTitle": "Ouvrir la galerie d'aperçu en direct",
    "stackTitle": "Stack cible",
    "loading": "Chargement des kits…",
    "notFound": "Aucun kit de design trouvé.",
    "bestFor": "Idéal pour :",
    "light": "Clair",
    "dark": "Sombre"
  },
  "worktrees": {
    "detached": "(détaché)",
    "count_one": "{{count}} worktree",
    "count_other": "{{count}} worktrees",
    "baseSuffix": " · base {{base}}",
    "baseLabel": "base",
    "cleanOrphans": "Nettoyer les orphelins",
    "cleanOrphansTitle": "Supprimer tous les worktrees orphelins",
    "liveBusyTitle": "Un run est actif — arrêtez-le d'abord",
    "rescanTitle": "Re-scanner",
    "removed_one": "{{count}} worktree supprimé.",
    "removed_other": "{{count}} worktrees supprimés.",
    "failed": "Échec",
    "mergedIntoBase": "{{branch}} fusionné dans la base.",
    "conflictMerge": "Conflit en fusionnant {{branch}} : {{files}}",
    "seeGit": "voir git",
    "mergeFailed": "Échec de la fusion : {{reason}}",
    "unknownReason": "inconnu",
    "mergeConfirmTitle": "Fusionner {{branch}} dans {{base}} ?",
    "mergeConfirmMsg": "Squash-fusionne cette branche sur la branche de base. S'annule proprement en cas de conflit.",
    "mergeAction": "Fusionner",
    "removeConfirmTitle": "Supprimer {{branch}} ?",
    "removeConfirmMsg": "Supprime forcément le checkout du worktree et efface sa branche. Le travail non fusionné est perdu.",
    "empty": "Aucun worktree.",
    "emptyHint": "Les runs SDD / AutoPhase créent des worktrees isolés ici. Les orphelins des runs plantés apparaissent aussi.",
    "actOpenTerm": "Ouvrir dans le terminal",
    "actOpenFolder": "Ouvrir le dossier",
    "actViewChanges": "Voir les modifications",
    "actMerge": "Fusionner vers la base",
    "actRemove": "Supprimer / annuler",
    "live": "actif",
    "noUncommitted": "Aucune modification non validée",
    "commitsAhead_one": "{{count}} commit en avance",
    "commitsAhead_other": "{{count}} commits en avance",
    "more": "…{{count}} de plus"
  },
  "officeSettings": {
    "heading": "Plan de bureau",
    "headingHint": "Visualisez votre flotte comme un plan de bureau avec le statut des agents en direct.",
    "statAgents": "Agents",
    "statMail": "Courriel",
    "unreadSuffix": " non lu",
    "sectionView": "Affichage",
    "sectionDisplay": "Affichage",
    "sectionBackground": "Arrière-plan",
    "sectionRecent": "Activité récente",
    "eventsTrackedSuffix": " événements suivis",
    "recentHint": "Les envois de courriel, les spawns d'agents et les changements de statut apparaissent ici.",
    "sectionShortcuts": "Raccourcis",
    "sectionLegend": "Légende",
    "hudLabel": "HUD",
    "hudDesc": "Afficher l'overlay des statistiques de session en temps réel",
    "hudToggle": "Activer le HUD",
    "minimapLabel": "Mini-carte",
    "minimapDesc": "Afficher la mini-carte d'aperçu",
    "minimapToggle": "Activer la mini-carte",
    "controlsLabel": "Contrôles",
    "controlsDesc": "Afficher les contrôles de zoom et d'ajustement",
    "controlsToggle": "Activer les contrôles",
    "animateLabel": "Animer les arêtes",
    "animateDesc": "Animer le flux sur les connexions actives",
    "animateToggle": "Activer l'animation des arêtes",
    "legendLabel": "Afficher la légende",
    "legendDesc": "Afficher la légende de statut et de connexion",
    "legendToggle": "Activer la légende",
    "feedLabel": "Flux en direct",
    "feedDesc": "Bande inférieure de l'activité inter-processus récente",
    "feedToggle": "Activer le flux en direct",
    "fitView": "Ajuster",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière",
    "resetZoom": "Réinitialiser le zoom",
    "legendActive": "Actif (en cours)",
    "legendIdle": "Inactif",
    "legendError": "Erreur",
    "legendOffline": "Hors ligne",
    "bg": {
      "dots": "Points",
      "lines": "Lignes",
      "cross": "Croix",
      "none": "Aucun"
    }
  }
}
